import { render } from "./AuraRichText.vue?vue&type=template&id=4e75507e&ts=true"
import script from "./AuraRichText.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraRichText.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/components/AuraRichText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4e75507e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4e75507e', __exports__)) {
    api.reload('4e75507e', __exports__)
  }
  
  module.hot.accept("./AuraRichText.vue?vue&type=template&id=4e75507e&ts=true", () => {
    api.rerender('4e75507e', render)
  })

}


export default __exports__